import { render } from "./VerticalSteppers.vue?vue&type=template&id=6b77f258&scoped=true"
import script from "./VerticalSteppers.vue?vue&type=script&lang=js"
export * from "./VerticalSteppers.vue?vue&type=script&lang=js"

import "./VerticalSteppers.vue?vue&type=style&index=0&id=6b77f258&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src420387374/src/relsify-frontpage-website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b77f258"]])

export default __exports__